export function formatPrice (num, fixedDigits = 0) {
  const number = Number(num).toFixed(fixedDigits);
  return Number(number).toLocaleString("de-DE");
}
